import { RECEIVE_PROPERTY_INCOMES, REQUEST_PROPERTY_INCOMES } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_PROPERTY_INCOMES:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_PROPERTY_INCOMES: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        default:
            return state
    }
}
